/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1Creditcardpaymentresult200,
  GetApiV1Creditcardpaymentresult400,
  GetApiV1Creditcardpaymentresult401,
  GetApiV1Creditcardpaymentresult500,
  GetApiV1CreditcardpaymentresultQueryParams,
  GetApiV1CreditcardpaymentresultQueryResponse,
} from "../../types/creditCardPaymentResultController/GetApiV1Creditcardpaymentresult.ts";
import { creditCardPaymentResultGridViewModelPaginatedResponseSchema } from "../creditCardPaymentResultGridViewModelPaginatedResponseSchema.ts";

export const getApiV1CreditcardpaymentresultQueryParamsSchema = z.object({
  StartDate: z.optional(z.string()),
  EndDate: z.optional(z.string()),
  CompanyId: z.optional(z.coerce.number().int()),
  ClassStudents: z.optional(z.string()),
  StudentName: z.optional(z.string()),
  Cpf: z.optional(z.string()),
  Approved: z.optional(z.coerce.number().int()),
  Merchant: z.optional(z.string()),
  Serial: z.optional(z.coerce.number().int()),
  TransactionCode: z.optional(z.string()),
  SortField: z.optional(z.string()),
  SortDirection: z.optional(z.string()),
  page: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(25),
}) as unknown as ToZod<GetApiV1CreditcardpaymentresultQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1Creditcardpaymentresult200Schema = z.lazy(
  () => creditCardPaymentResultGridViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1Creditcardpaymentresult200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1Creditcardpaymentresult400Schema =
  z.any() as unknown as ToZod<GetApiV1Creditcardpaymentresult400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1Creditcardpaymentresult401Schema =
  z.any() as unknown as ToZod<GetApiV1Creditcardpaymentresult401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1Creditcardpaymentresult500Schema =
  z.any() as unknown as ToZod<GetApiV1Creditcardpaymentresult500>;

export const getApiV1CreditcardpaymentresultQueryResponseSchema = z.lazy(
  () => getApiV1Creditcardpaymentresult200Schema,
) as unknown as ToZod<GetApiV1CreditcardpaymentresultQueryResponse>;
